import { FC, memo } from 'react';
import { IconSize, IconType, IconWrap } from '@tools/ui/dime';
import { TransactionDirection } from '@tools/ui/types/generated/graphql';

type TProps = {
  direction?: string;
};

const FundsDirection: FC<React.PropsWithChildren<TProps>> = ({ direction }) => {
  const fundsDirection =
    direction?.toUpperCase() === TransactionDirection.CREDIT
      ? IconType.CreditDirection
      : IconType.DebitDirection;

  return <IconWrap size={IconSize.Small} type={fundsDirection} />;
};
export default memo(FundsDirection);
